import React, { useState } from 'react';
import ModalHelp from 'modals/modalHelp/ModalHelp';
import './Sidebar.scss';

interface Logout {
    name: string;
    icon: string;
    codeMenu: string;
}

interface Help {
    name: string;
    icon: string;
    codeMenu: string;
}

interface SidebarProps {
    logo: string;
    sections: any;
    logout: Logout;
    help?: Help;
    handleClick: (name: object) => void
}

const Sidebar: React.FC<SidebarProps> = ({ logo, sections, logout, handleClick , help }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [ showModalHelp , setShowModalHelp ] = useState(false);
    
    const handleSeeHelp = () => {
        setShowModalHelp(true);
    }
    return <>
        <div className={`tapps-sidebar ${isMenuOpen ? 'open' : '' }`}>
            <div className="tapps-sidebar-btnResponsive" aria-hidden="true" role="button" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                <div className={ `toggleButton ${isMenuOpen ? '' : 'close' }` }>
                    <div className="bar1 bars">&nbsp;</div>
                    <div className="bar2 bars">&nbsp;</div>
                    <div className="bar3 bars">&nbsp;</div>
                </div>
            </div>
            <div className="tapps-sidebar-logo">
                <img src={logo} alt="Logo" />
            </div>
            <div className="tapps-sidebar-boxes">
                <div className="tapps-sidebar-boxes-box">
                    {
                        sections.map((sec: any, index: number) => <div key={index}>
                            {
                                index !== 0 && <div className="tapps-sidebar-boxes-box-separator"></div>
                            }
                            <div className="tapps-sidebar-boxes-box-name">
                                {sec.name}
                            </div>
                            {sec.options.map((option: any) => (
                                <div
                                    key={option.codeMenu}
                                    className={`tapps-sidebar-boxes-box-option ${option.active ? 'active' : ''}`}
                                    aria-hidden="true"
                                    role="button"
                                    onClick={() => handleClick(option)}
                                >
                                    <div className="tapps-sidebar-boxes-box-option-icon">
                                        <i className={`iconwhite-${option.icon}`}></i>
                                    </div>
                                    <div className="tapps-sidebar-boxes-box-option-text">{option.name}</div>
                                </div>
                            ))}  
                        </div>)
                    }
                </div>
                <div className="tapps-sidebar-boxes-box">
                    {
                        help &&
                        <div
                            className="tapps-sidebar-boxes-box-option"
                            aria-hidden="true"
                            role="button"
                            onClick={ () => handleSeeHelp() }
                        >
                            <div className="tapps-sidebar-boxes-box-option-icon">
                                <i className={`iconwhite-${help.icon}`}></i>
                            </div>
                            <div className="tapps-sidebar-boxes-box-option-text">{help.name}</div>
                        </div>
                    }

                    <div
                        className="tapps-sidebar-boxes-box-option logout"
                        aria-hidden="true"
                        role="button"
                        onClick={() => handleClick(logout)}
                    >
                        <div className="tapps-sidebar-boxes-box-option-icon">
                            <i className={`iconwhite-${logout.icon}`}></i>
                        </div>
                        <div className="tapps-sidebar-boxes-box-option-text">{logout.name}</div>
                    </div>
                </div>
            </div>
        </div>

        {
            showModalHelp && (
                <ModalHelp
                    handleCancel={ () => setShowModalHelp(false) }
                />
            )
        }
    </>;
};

export default Sidebar;
